document.addEventListener("DOMContentLoaded", function () {
  // Function to get USA (New York) time
  function getUSADate() {
    return new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
  }

  const TIMER_KEY = "usa_timer_end_time_shared"; // shared timer key for both sections
  const COUNTDOWN_MINUTES = 55; // countdown duration (55 mins)

  let now = getUSADate();
  let endTime;

  // Check if saved timer exists in localStorage
  const savedEndTime = localStorage.getItem(TIMER_KEY);
  if (savedEndTime) {
    endTime = new Date(savedEndTime);
    // If saved timer expired → reset
    if (endTime <= now) {
      endTime = new Date(now.getTime() + COUNTDOWN_MINUTES * 60 * 1000);
      localStorage.setItem(TIMER_KEY, endTime.toISOString());
    }
  } else {
    // First visit → start new 55-min timer
    endTime = new Date(now.getTime() + COUNTDOWN_MINUTES * 60 * 1000);
    localStorage.setItem(TIMER_KEY, endTime.toISOString());
  }

  function updateTimer() {
    const currentUSA = getUSADate();
    let diff = endTime - currentUSA;

    // If time is finished, reset the timer
    if (diff <= 0) {
      endTime = new Date(currentUSA.getTime() + COUNTDOWN_MINUTES * 60 * 1000);
      localStorage.setItem(TIMER_KEY, endTime.toISOString());
      diff = endTime - currentUSA;
    }

    const totalSeconds = Math.floor(diff / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const seconds = totalSeconds % 60;

    // Update all timers that have hours/minutes/seconds
    document.querySelectorAll(".ah_timer-hours")?.forEach(el => {
      el.textContent = String(hours).padStart(2, "0");
    });

    document.querySelectorAll(".ah_timer-minutes, .sticky_timer-minutes")?.forEach(el => {
      el.textContent = String(minutes).padStart(2, "0");
    });

    document.querySelectorAll(".ah_timer-seconds, .sticky_timer-seconds")?.forEach(el => {
      el.textContent = String(seconds).padStart(2, "0");
    });
  }

  updateTimer();
  setInterval(updateTimer, 1000);
});
